<div class="uhc-modal-box ">
  <div class="uhc-modal-header">
    <h4 class="uhc-h4">Notice</h4>
  </div>
  <div class="uhc-modal-content">
    <p [innerHTML]="data.message">
    </p>
  </div>
  <div class="uhc-modal-footer">
    <button class="uhc-button uhc-primary" (click)="ok()">Ok</button>
  </div>
</div>